import React from 'react'

/**
 * The standard page wrapper for admin pages. Every top-level page rendered
 * inside <Layout> starts with this. Provides the centered width, responsive
 * padding, and fade-in animation used everywhere in the dashboard.
 *
 * Usage:
 *   <PageContainer>
 *     <PageHeader ... />
 *     <SectionCard>...</SectionCard>
 *   </PageContainer>
 */
export interface PageContainerProps {
  className?: string
  children: React.ReactNode
}

export function PageContainer({ className = '', children }: PageContainerProps) {
  return (
    <div className={`p-6 lg:p-8 max-w-6xl mx-auto animate-fade-in ${className}`}>
      {children}
    </div>
  )
}
